<div>
  <app-breadcrumb></app-breadcrumb>
</div>

<mat-card>
    <mat-card-content>
        <div class="table-header">
            <h2>Liste des utilisateurs</h2>
            <button mat-raised-button color="primary" (click)="redirectToCreateUser()">
              <mat-icon>add</mat-icon> CRÉER UN UTILISATEUR
            </button>
        </div>

        <mat-divider></mat-divider>

        <div>
          <form [formGroup]="filter">
            <div class="filter-reset">
              <button mat-raised-button (click)="resetFilters()" [disabled]="!filtersActive" [class.button-disabled]="!filtersActive" class="button-reset">
                Réinitialiser les filtres
              </button>
            </div>
            <div class="filter">                  
              <mat-form-field appearance="outline" class="general-filter">
                  <mat-label><mat-icon>search</mat-icon> Liste des utilisateurs</mat-label>
                  <input type="text" placeholder="Prénom, nom, téléphone, e-mail"  matInput formControlName="general_filter">
                  @if(filter.controls['general_filter'].value) {
                      <mat-icon matSuffix mat-icon-button (click)="clearGeneralFilter()" >close</mat-icon>
                  }
              </mat-form-field>                                   
              <mat-form-field appearance="outline" class="fonction-filter">
                <mat-select (selectionChange)="applyFilterType($event.value)" placeholder="Sélectionnez une fonction" formControlName="fonction">
                    @for(fonction of fonctions; track fonction){
                        <mat-option [value]="fonction">{{ fonction }}</mat-option>
                    }
                </mat-select>
              </mat-form-field>                  
            </div>
          </form>
      </div>

        <mat-divider></mat-divider>

        <div class="mat-elevation-z8">
            <mat-table [dataSource]="dataSource" matSort>    
      
              <ng-container matColumnDef="surname">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Prénom</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.surname}} </mat-cell>
              </ng-container>
            
              <ng-container matColumnDef="givenName">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>Nom</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.givenName}} </mat-cell>
              </ng-container>
            
              <ng-container matColumnDef="mobilePhone">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Téléphone </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.mobilePhone}} </mat-cell>
              </ng-container>
      
              <ng-container matColumnDef="mail">
                <mat-header-cell *matHeaderCellDef mat-sort-header> E-mail </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.mail}} </mat-cell>
              </ng-container>
          
              <ng-container matColumnDef="fonction">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Fonction </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{ getProfilsLibelle(element) }} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="actions">
                  <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
                  <mat-cell *matCellDef="let element"> 
                    <mat-icon (click)="redirectToEditUser(element.id)">edit</mat-icon>
                    <mat-icon (click)="openDeleteDialog(element.id)">delete</mat-icon>
                  </mat-cell>
              </ng-container>

              <div class="no-data" *matNoDataRow>
                <b>Aucun utilisateur</b>
            </div>

              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        
            </mat-table>
          
            <mat-paginator [pageSizeOptions]="[10, 15, 20]"
              showFirstLastButtons
              aria-label="Select page of periodic elements">
            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>
